import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface RegistroResumoModel {
    id: number
    nome: string
    qtdRegistros: number
    qtdResgatesEfetuados: number
    qtdPedidos: number
    valorVendas: number
    valorVendasOnline: number
    valorVendasOnlinePix: number
    comissaoVendasOnline: number
    comissaoVendasOnlinePix: number
    valorFretes: number
    qtdClientes: number
    mediaAvaliacoesDelivery: number
    mediaAvaliacoesGeral: number
    mensalidade: number
    comissaoOnline: number
    saldoOnline: number
    chargebacks: number
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    ) {
        const d = data as RespostaErroRaw
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterComparativoUnidades = async function (
    authorization: string,
    dataInicio: string,
    dataFim: string
): Promise<RegistroResumoModel[] | ErroApi> {
    try {
        const response = await api
            .get<RegistroResumoModel[] | RespostaErroRaw>(
                `fornecedor/ObterComparativoUnidades?dataInicio=${dataInicio}&dataFim=${dataFim}`,
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as RegistroResumoModel[]
    } catch (error) {
        RegistrarLogErro(error, "obterComparativoUnidades", `${dataInicio}/${dataFim}`)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
